import Collection from '../../collection';
import CommentsLive from '../../service/comments';
import Config from '../../config';
import Module from '../../core/module';
import Task from '../../model/task';
import TaskFilter from '../../view/tasks.filter';

import { TaskNew, newTask } from '../../view/task.new';
import { Insert } from '../../service/live';
import { fetch } from '../../collection/comments';
import { ask, } from '../../utils/popups';
import { promisify, requestify, deferred, } from '../../utils/promisify';
import { hashify } from '../../utils/arrays';
import { beginLock, endLock } from '../../loader';





const     
    OPEN_TASK = 'tasks-form-open',
    OPEN_LIST = 'tasks-list-open',
    OPEN_MAP = 'tasks-map-open',
    OPEN_CONTRACTS = 'contracts-list-open';

export default Module.extend( {

    initialize(options = {}) {
        Module.prototype.initialize.call( this, options );

        let form;
        const self = this;

        const actions = this.options.actions = {
            
            defaults: 'edit',
        
            multitask() {
                const { 
                    layers, datatables, clusters,
                    types, organizations, contracts,
                    statuses, priorities, fields, 
                    serviceObjectMappings,
                    locationService
                } = options;
                if (!form)
                    form = new TaskNew( { 
                        layers, datatables, clusters,
                        locationService,
                        types, organizations, contracts,
                        statuses, priorities,
                        fields,
                        serviceObjectMappings, 
                    } );

                promisify( newTask( form, priorities ) )
                    .then( () => beginLock( self ) )
                    .then( () => issues.fetch() )
                    .then( () => endLock( self ) );
            },
            
            edit(current) {
                self.trigger( OPEN_TASK, current );
            },
            
            destroy(current) {
                ask( 'issue::modal delete - confirmation text',
                    'issue::modal delete - title', 'actions::yes', 'actions::no',
                    () => deferred( requestify( $.ajax( {
                        url: Config.url( `/news/${current.id}` ),
                        dataType: 'json',
                        data: JSON.stringify( { action: 'delete' } ),
                        method: 'POST',
                        contentType: 'application/json; charset=UTF-8',
                    } ) ) ).then( resp => {
                        if (!+resp.res)
                            return $.Deferred().reject( resp.resText );
                    } ).done( () => {
                        beginLock( this );
                        issues.fetch().then( () => endLock( this ) ); 
                    } ) );
            },
        };
        
        const issues = this.options.issues = new Collection( {
            endpoint: 'tasks/list/with-comments?apiVersion=2.1&sortBy=id&sortDirection=DESC&limit=7',
            responseAt: 'items',
            countAt: 'total',
            actions: actions,
            model: Task,
            parseResponse(modelsAttrs, { active_id, schedules }) {
                schedules = hashify( schedules, schedule => [schedule.id, schedule] );

                return modelsAttrs.map( ({ comments, task, capabilities, ...attrs }) => {
                    const taskAttrs = { 
                        id: task.id,
                        task,
                        schedule: schedules[task.schedule_id],
                        capabilities, 
                        ...attrs };

                    if (task.id != active_id)
                        taskAttrs.lastComment = comments[0];
                    else
                        taskAttrs.comments = comments;

                    return taskAttrs;
                } );
            }
        } );

        this.setState( {
            filters: TaskFilter.defaultFilters(),
        } );

        this.commentsChannel = CommentsLive
            .filter( message => message instanceof Insert )
            .forEach( message => this.trigger( 'comments:income', message.model ) ); // model === attrs of Model
    },

    template: 'jst/module.tasks.list',

    url() {
        return 'tasks';
    },

    open() {
        const { issues } = this.options;

        const httpFilters = getHttpFilters( this.state() );
        const { page, filters, activeId, } = this.state();
        
        return promisify( issues.filter( httpFilters, page, activeId ) )
            .then( () => this.render() )
            .then( () => {
                const filter = this.Filter.bind( new TaskFilter.Model( filters ) );
                const current = issues.current();
                if (!current)
                    return filter;

                return this.setState( { activeId: current.id } ),
                    Promise.all( [filter, this.Map.bind( current )] );
             } )
            .then( () => this );
    },

    start() {
        const { issues } = this.options;
        let lastFiltering = Promise.resolve();

        issues.plugActionSource( this.Grid );

        // this.listenTo( this.Search, 'search', queryString => 
        //     lastFiltering = lastFiltering
        //         .then( () => {
        //             this.setState( { queryString, } );
        //             this.navigated();
        //             return issues.filter( getHttpFilters( this.state() ) );
        //         } )
        //         .catch( () => undefined ) );

        if (issues.current())
            this.Comments.bind( issues.current() );

        this.Map.listenTo( issues, 'activate deactivate', 
            () => {
                const current = issues.current();
                const activeId = current ? current.id : undefined;
                if (this.state().activeId == activeId)
                    return;

                this.setState( { activeId, } );
                this.navigated();

                if (current && !current.comments_)
                    fetch( current.id ).then( ([json, coll]) =>
                        current.trigger( 'comments:load', current.comments_ = json ) );

                this.Map.bind( issues.current() );
                this.Comments.bind( issues.current() );
            } );

        this.listenTo( this, 'comments:income',
            comment => handleIncomingComment.call( this, comment ) );

        this.Filter.focus();
    },

    stop() {
        const { issues } = this.options;

        issues.unplugActionSource( this.Grid );
        this.Grid.ungrab( issues );
        this.Paging.ungrab( issues );

        this.stopListening( this.Paging );
        this.stopListening( this.Filter );
        this.stopListening( this, 'comments:income' );

        this.Map.stopListening( issues );

        return this;
    },

    serialize() {
        const { issues, types, priorities, statuses, 
            contracts, organizations,
            locationService, } = this.options;

        return {
            queryString: this.state().queryString || '',
            actionList: issues.actions,
            collection: issues,
            types, 
            statuses,
            priorities,
            contracts, organizations,
            locationService,
        };
    },

    events: {

        'keyup [name=title]'(e) {
            if (13 == e.keyCode)
                this.Grid.trigger( 'action:default' ),
                e.preventDefault();
        },

        'keydown [name=title]'(e) {
            switch (e.keyCode) {
                case 38: 
                    this.options.issues.prevRow();
                    break;
                case 40: 
                    this.options.issues.nextRow();
                    break;
            }
        },

    },

    [Module.event( 'Paging:page' )](page) {
        this.setState( { page, } );
        this.navigated();
        beginLock( this );
        this.options.issues.setPage( page )
            .then( () => endLock( this ) );
    },

    [Module.event( 'Filter:filter' )](filters) {
        this.setState( { filters, } );
        this.navigated();
        this.Grid.afterRendering().then( () => 
            this.options.issues.filter( getHttpFilters( this.state() ) ) ); 
    },

    [Module.event( 'Comments:comments:recalc-unread' )]() {
        this.Grid.render();
    },

    [Module.event( 'nav:map' )]() {
        this.trigger( OPEN_MAP, this.state() );
    },

    [Module.event( 'nav:contracts' )]() {
        this.trigger( OPEN_CONTRACTS, this.state() );
    },

}, {

    OPEN_TASK,

    OPEN_LIST,

    OPEN_MAP,

    OPEN_CONTRACTS,

} );

function getHttpFilters(tasksModuleState) {
    const { filters, activeId, } = tasksModuleState;
    const { assigned_status, category_id, news_type_id, confirmed,
        assigned_organization_id, assigned_user_id,
        contract_id, organization_id,
        title, } = filters;
    
    const result = {};
    if (+assigned_organization_id > 0) result.assignedOrganizationId = assigned_organization_id;
    if (+assigned_user_id > 0) result.assignedUserId = assigned_user_id;
    if (+organization_id > 0) result.organizationId = organization_id;
    if (+contract_id > 0) result.contractId = contract_id;
    if (assigned_status) result.onlyStatus = assigned_status;
    if (category_id) result.category_id = category_id;
    if (news_type_id) result.type_id = news_type_id;
    if (confirmed) result.confirmed = confirmed;
    if (title) result.search = title;
    if (activeId) result.id = activeId;
            
    return result;
}

function handleIncomingComment(commentJson) {
    const { issues: tasks } = this.options;
    
    const taskId = +commentJson.task_id || +commentJson.news_id;
    const task = tasks.find( m => m.id === taskId );
    if (!task)
        return;

    task.set( 'lastComment', commentJson );
    if (task.comments_ && task.comments_ instanceof Array)
        task.comments_.unshift( commentJson );

    if (commentJson.user_id == Config.userId())
        return task.set( 'unread_message_count', 0 ), this.Grid.render();

    const unread = task.get( 'unread_message_count' );
    if (unread === null)
        return this.Grid.render();

    task.set( 'unread_message_count', unread + 1 ),
    task.trigger( 'comments:unread-incoming' );

    this.Grid.render();
}


// WEBPACK FOOTER //
// ./src/js/module/tasks/list.js